import { useQuery } from '@tanstack/react-query';
import api from '../lib/api';
import type { StatsResponse } from '@shared/types/api';

async function fetchStats(): Promise<StatsResponse> {
    const { data } = await api.get<StatsResponse>('/stats');
    return data;
}

export function useStats() {
    return useQuery({
        queryKey: ['stats'],
        queryFn: fetchStats,
    });
}
